import React from "react";
import { Link } from "react-router-dom";
import { htmlToExcerpt } from "../../utils/sanitizeHtml";

/**
 * LinkedIn-style article teaser for the feed.
 */
export const BLOG_CARD_PROPS = {
  badge: "Blog",
  readLabel: "Read blog →",
  badgeColor: "#0f766e",
  badgeBackground: "#ccfbf1",
};

export default function ArticleCard({
  post,
  linkPrefix = "/home/article",
  interactive = true,
  badge = "Article",
  readLabel = "Read article →",
  badgeColor = "#0369a1",
  badgeBackground = "#e0f2fe",
}) {
  const excerpt = htmlToExcerpt(post.content || post.text || "", 150);
  const cover = post.cover_image || null;
  const mobile = typeof window !== "undefined" && window.innerWidth <= 768;
  const canLink = interactive && !!linkPrefix;
  const Wrapper = canLink ? Link : "div";
  const wrapperProps = canLink
    ? {
        to: `${linkPrefix}/${post.id}`,
        style: { textDecoration: "none", color: "inherit", display: "block" },
      }
    : { style: { color: "inherit", display: "block" } };

  return (
    <div style={{ marginTop: 4 }}>
      <Wrapper {...wrapperProps}>
        {cover && (
          <img
            src={cover}
            alt={post.title || `${badge} cover`}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: 10,
              marginBottom: 12,
              objectFit: "contain",
              display: "block",
            }}
          />
        )}
        <div
          style={{
            display: "inline-block",
            fontSize: mobile ? 12 : 11,
            fontWeight: 600,
            letterSpacing: 0.4,
            textTransform: "uppercase",
            color: badgeColor,
            background: badgeBackground,
            padding: "3px 8px",
            borderRadius: 4,
            marginBottom: 8,
          }}
        >
          {badge}
        </div>
        <h3
          style={{
            fontSize: mobile ? 22 : 20,
            fontWeight: 700,
            color: "#102a43",
            margin: "0 0 8px",
            lineHeight: 1.3,
          }}
        >
          {post.title}
        </h3>
        {excerpt && (
          <p
            style={{
              margin: "0 0 10px",
              fontSize: mobile ? 16 : 14,
              color: "#475569",
              lineHeight: 1.55,
            }}
          >
            {excerpt}
          </p>
        )}
        {canLink && (
          <span
            style={{
              fontSize: mobile ? 15 : 14,
              fontWeight: 600,
              color: "#0284c7",
            }}
          >
            {readLabel}
          </span>
        )}
      </Wrapper>
    </div>
  );
}
